import { render } from "./searchbar.vue?vue&type=template&id=05135950&scoped=true&lang=html"
import script from "./searchbar.vue?vue&type=script&lang=js"
export * from "./searchbar.vue?vue&type=script&lang=js"

import "./searchbar.vue?vue&type=style&index=0&id=05135950&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05135950"]])

export default __exports__